import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.nav `
  display: flex;

  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const List = styled.ul `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 94vw;
`;
const Item = styled.li `
  display: flex;
  align-items: center;
  ${fonts.matter.regular};
  font-size: 20px;
  justify-content: flex-start;
  line-height: 28px;

  &:not(:last-child)::after {
    content: '|';
    padding: 0 4px;
  }

  &:last-child {
    ${fonts.matter.medium};
    overflow: hidden;

    span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &:focus,
      &:hover {
        text-decoration: none;
      }
    }
  }
`;
const Link = styled.a `
  display: block;
  color: currentColor;
  text-decoration: none;
  text-underline-position: under;
  white-space: nowrap;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
export default {
    Container,
    Item,
    Link,
    List,
};
